module.exports = __webpack_public_path__ + "img/pompier.9539a275.png";